import SchemePopupLayout from "./SchemePopupLayout";

const VirasatSchemePopup = ({ onClose }) => {
  return (
    <SchemePopupLayout
      title="Virasat Scheme"
      intro="The Virasat Scheme supports traditional artisans and craftspeople from minority communities by providing financial assistance for tools, equipment, raw materials, and business development. The scheme aims to preserve traditional craftsmanship while promoting self-employment and sustainable livelihoods."
      eligibility={[
        "Applicant must belong to a notified minority community.",
        "Annual family income should fall within NMDFC income limits.",
        "Applicant should be involved in traditional crafts or artisan-related work.",
        "Must be an Indian citizen above 18 years of age.",
      ]}
      documents={[
        "Aadhaar Card / Identity Proof",
        "Address Proof",
        "Passport-size Photograph",
        "Income Certificate",
        "Minority Community Certificate",
        "Bank Account Details",
        "Artisan/Skill Proof (if applicable)",
        "Quotation for tools or equipment",
      ]}
      applyLabel="Apply for Virasat Scheme"
      videoUrl="https://www.youtube.com/embed/lgffjDj_A50"
      onClose={onClose}
    />
  );
};

export default VirasatSchemePopup;
